export default {
  'menu.relationships': 'Relationships',
  'pages.relationships.action.block': 'Block',
  'pages.relationships.action.blockConfirm': 'Block this user?',
  'pages.relationships.action.detail': 'Detail',
  'pages.relationships.action.refresh': 'Refresh',
  'pages.relationships.action.reset': 'Reset',
  'pages.relationships.action.unblock': 'Unblock',
  'pages.relationships.action.unblockConfirm': 'Unblock this user?',
  'pages.relationships.block.title': 'Block relationship',
  'pages.relationships.column.action': 'Action',
  'pages.relationships.column.addSource': 'Add source',
  'pages.relationships.column.addTime': 'Add time',
  'pages.relationships.column.amBitId': 'AmBit ID',
  'pages.relationships.column.avatarUrl': 'Avatar',
  'pages.relationships.column.blockRelation': 'Block relation',
  'pages.relationships.column.blockedByUser': 'Blocked by current user',
  'pages.relationships.column.blockedUser': 'Blocked current user',
  'pages.relationships.column.createdAt': 'Created at',
  'pages.relationships.column.friendUid': 'Friend UID',
  'pages.relationships.column.localProfileFound': 'Local profile',
  'pages.relationships.column.nickname': 'Nickname',
  'pages.relationships.column.raw': 'Raw',
  'pages.relationships.column.relationshipStatus': 'Relationship status',
  'pages.relationships.column.showId': 'Show ID',
  'pages.relationships.column.status': 'Status',
  'pages.relationships.column.timStatus': 'TIM status',
  'pages.relationships.column.updatedAt': 'Updated at',
  'pages.relationships.column.userId': 'User ID',
  'pages.relationships.detail.basic': 'Basic info',
  'pages.relationships.detail.extra': 'Extra',
  'pages.relationships.detail.relationship': 'Relationship',
  'pages.relationships.detail.status': 'Status',
  'pages.relationships.detail.title': 'Relationship detail: {uid}',
  'pages.relationships.empty.detail': 'No data',
  'pages.relationships.empty.result': 'No result',
  'pages.relationships.field.blockedUid': 'Blocked UID',
  'pages.relationships.field.blockerUid': 'Blocker UID',
  'pages.relationships.field.reason': 'Reason',
  'pages.relationships.message.missingCurrentUid': 'Missing current user UID',
  'pages.relationships.message.missingTargetUid': 'Missing target user UID',
  'pages.relationships.message.saved': 'Done',
  'pages.relationships.search.uid': 'User UID',
  'pages.relationships.title': 'Relationships',
  'pages.relationships.unblock.title': 'Unblock relationship',
  'pages.relationships.value.blockRelation.aWithB': 'Blocked by current user',
  'pages.relationships.value.blockRelation.bWithA': 'Blocked by target user',
  'pages.relationships.value.blockRelation.bothWay': 'Mutual block',
  'pages.relationships.value.blockRelation.no': 'No block',
  'pages.relationships.value.no': 'No',
  'pages.relationships.value.relationship.friend': 'Friend',
  'pages.relationships.value.yes': 'Yes',
};
